<div class="table-container">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange($event)">
    @for (column of displayedColumns; track column; let i = $index) {
      <ng-container matColumnDef="{{column}}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{displayedColumnHeaders[i]}} </th>
        <td mat-cell *matCellDef="let element">
          @if (column === 'userName') {
            {{element.userName}}
            }@else if (column === 'createdDate') {
            <span>{{element.createdDate | date:'medium'}}</span>
            }@else {
            {{element[column] | number}}
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
